import { render, staticRenderFns } from "./insWrongRecord.vue?vue&type=template&id=4580560c&scoped=true"
import script from "./insWrongRecord.vue?vue&type=script&lang=js"
export * from "./insWrongRecord.vue?vue&type=script&lang=js"
import style0 from "./insWrongRecord.vue?vue&type=style&index=0&id=4580560c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580560c",
  null
  
)

export default component.exports